<template>
  <div id="page-not-found" class="page">
    <header class="header -column">
      <div class="header__content">
        <h1 v-reveal="{ delay: 550 }" class="header__title">Page 404</h1>
        <h2 v-reveal="{ delay: 600 }" class="header__subtitle">Cette page n'existe pas.</h2>

        <RouterLink :to="{ name: 'home' }" class="button -link">Retourner à l'accueil</RouterLink>
      </div>
    </header>
  </div>
</template>

<script>
import { setMeta } from '@/helpers/metaHelpers.js'

export default {
  name: 'NotFound',
  beforeMount() {
    if (this.$route.name.includes('catch-all')) this.$router.replace({ name: 'not-found' })
  },
  mounted() {
    setMeta({
      description:
        'L’initiative Ville Éponge vise à encourager et appliquer l’innovation écoresponsable dans les pratiques de gestion des eaux et de verdissement.',
      title: '404 - Page Introuvable',
    })
  },
}
</script>
